import Toast from "./Toast";
import { postRequest } from "../api/apiServices";
import apiList from "../api/apiList";

export const getAIImages = async (prompt, assistantId, threadId) => {
  if (!prompt || typeof prompt !== "string" || prompt.trim().length === 0) {
    Toast("Please Enter Some Data...!", "warning");
    return;
  }

  if (!assistantId || !threadId) {
    Toast("Assistant ID or Thread ID missing!", "error");
    return;
  }

  try {
    const payload = { prompt, assistantId, threadId };
    const response = await postRequest(apiList.generateImage, payload);

    // Normalize various possible backend shapes into array of URLs
    const res = response?.data;
    const data = res?.data ?? res;

    if (Array.isArray(data)) {
      // Could be array of strings or objects with url
      if (typeof data[0] === "string") return data;
      if (data[0]?.url) return data.map((x) => x.url);
    }

    if (Array.isArray(res?.images)) {
      if (typeof res.images[0] === "string") return res.images;
      if (res.images[0]?.url) return res.images.map((x) => x.url);
    }

    if (Array.isArray(res?.data?.data)) {
      // OpenAI-like nesting
      return res.data.data.map((x) => x.url).filter(Boolean);
    }

    Toast("No images returned from the server.", "warning");
    return [];
  } catch (error) {
    console.error("Error generating image:", error);
    throw new Error("Failed to generate image");
  }
};
